export default __webpack_public_path__ + "static/media/Loader-01.4e4a9ebf.gif";